import RowSectionComponent from "../../components/search/rowsSection/rowsSectionComponent";
import VirtualKeyboard from "../../components/search/virtualKeyboard/VirtualKeyboard";
import SearchResultContextProvider from "../../modules/search/searchContext/SearchResultProvider";
import * as styles from "./styles.module.scss";
const SearchPage = () => {
  return (
    <SearchResultContextProvider>
      <section className={styles.container}>
        <VirtualKeyboard />
        <RowSectionComponent />
      </section>
    </SearchResultContextProvider>
  );
};
export default SearchPage;
